import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  notification,
  Divider,
  Icon,
  Rate,
  Row
} from 'antd';
import { formatCurrency, responsiveSliderSettings } from '../../../../utils/utils';
import ProductShort from '../../../shared/Product/ProductShort';
import ProductOptions from '../../ProductOptions';
import ProductExtras from '../ProductExtras';
import ProductSliderDesktop from './ProductSliderDesktop';
import Settlements from '../Settlements';
import ProductTechnologies from '../ProductTechnologies';
import { apiImageStatic } from '../../../../../config/config';

const HtmlToReactParser = require('html-to-react').Parser;

const ProductDesktop = ({
  activeGalleryPhoto,
  addProductToCart,
  addProductToFavorites,
  addToFavorites,
  customer,
  decrementQuantity,
  favorites = [],
  incrementQuantity,
  onQuantityChange,
  product,
  quantity,
  settings,
  setVariant,
  t,
  variant
}) => {
  const isLong = product.layout === 'list';
  const isFavorite = favorites.some((favorite) => favorite === product._id);
  const longDescription = product.description ? product.description.long : '';
  const htmlToReactParser = new HtmlToReactParser();
  const productLongDescription = htmlToReactParser.parse(longDescription);
  const [licence, setLicence] = useState(false);
  const [outOfStockVariant, setOutOfStockVariant] = useState(false);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const licenceChange = () => setLicence(!licence);

  // console.log('[SINGLE PRODUCT] ', product);
  // console.log(product.layout);

  useEffect(() => {
    // if (!product.licenseType) {
    //   setLicence(true);
    // }
    if (product?.variants?.length === 0) {
      setIsOptionSelected(true);
    }
  }, []);

  const getDownloadLink = (licenseType) => {
    // eslint-disable-next-line default-case
    switch (licenseType) {
      case 'army':
        return `${apiImageStatic}/pdfs/FAQ_Πυροβόλα.pdf`;
      case 'bullets':
        return `${apiImageStatic}/pdfs/FAQ_Φυσίγγια_Πυροβόλων`;
      case 'hunt':
        return `${apiImageStatic}/pdfs/FAQ_Κυνηγητικά_όπλα`;
    }
  };

  const getLicenseType = (licenseType) => {
    // eslint-disable-next-line default-case
    switch (licenseType) {
      case 'army':
        return t('ProductInfo.license.armyCheckbox');
      case 'over18':
        return t('ProductInfo.license.over18Checkbox');
      case 'bullets':
        return t('ProductInfo.license.bulletsCheckbox');
      case 'hunt':
        return t('ProductInfo.license.hunterCheckbox');
    }
  };

  const tryAddProductToCart = (prod) => {
    // if (!licence) {
    //   return notification.error({
    //     message: t('ProductInfo.license.notSelectedNotification'),
    //     className: 'custom-notification'
    //   });
    // }
    // console.log('outOfStockVariant', prod)
    if (outOfStockVariant) {
      return notification.error({
        message: t('ProductInfo.outOfStockNotification'),
        className: 'custom-notification'
      });
    }
    if (!isOptionSelected) {
      return notification.error({
        message: `${t('ProductInfo.noOptionSelectedPart1')} ${
          prod.options[0].display_name
        } ${t('ProductInfo.noOptionSelectedPart2')}`,
        className: 'custom-notification'
      });
    }

    addProductToCart(prod);
  };

  const showProductPrice = () => {
    let type = product;
    if (variant) {
      type = variant;
    }

    return type?.onSale?.value ? (
      <Row type="flex" justify="space-between" align="bottom">
        <Col>
          <Row type="flex" justify="start" align>
            <Col>
              <div className="text-36-normal text-30-5s">
                {formatCurrency(type.sale.salePrice, settings)}
              </div>
            </Col>
            <Col>
              <div className="text-14-normal-price-from align-items-bottom ml-20 pt-3">
                {t('from')}
              </div>
            </Col>
            <Col>
              <div className="text-16-mute pr-1 pl-1 line-through pt-3">
                {formatCurrency(type.price, settings)}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    ) : (
      <div className="d-flex align-items-center">
        <div className="text-24-bold-price pr-1 pl-1">
          {formatCurrency(type.price, settings)}
        </div>
        {product.onSale.value ? (
          <div className="circle-item last-item">-{product.sale.percentage}%</div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <>
        <Row className="mt-60" type="flex" justify="start">
          {/* product sliders and main */}
          <Col
            className={
              isLong
                ? 'product-slider-list mb-60'
                : 'product-slider-grid mb-60 ml-40-desktop'
            }
            xs={24}
            xl={isLong ? 24 : 12}
          >
            <ProductSliderDesktop
              isLong={isLong}
              activeGalleryPhoto={activeGalleryPhoto}
              product={
                variant ? (variant.images.length > 0 ? variant : product) : product
              }
              productId={
                variant
                  ? variant.images.length > 0
                    ? variant._id
                    : product._id
                  : product._id
              }
              sliderImages={
                variant
                  ? variant.images.length > 0
                    ? variant.images
                    : product.images
                  : product.images
              }
              sliderVideos={
                variant
                  ? variant.videos.length > 0
                    ? variant.videos
                    : product.videos
                  : product.videos
              }
              type={product.layout === 'list' ? 'list' : 'grid'}
            />
          </Col>
          {/* product sku, price, buy, fav */}
          <Col
            className={isLong ? 'product-col-buy-list' : 'product-col-buy-grid'}
            xs={24}
            xl={10}
            order={isLong ? 2 : 1}
          >
            {/* limited quantity neo proion */}
            <Row className="mb-10">
              {/* neo proion */}
              <Col xs={24} xl={20}>
                <Row gutter={50} type="flex" justify="space-between">
                  <Col>
                    <div className="subtitle-text">{product.subtitle}</div>
                  </Col>
                  {/* <Col>
                    <Row type="flex" justify="end">
                      <Col>
                        <Rate
                          style={{ fontSize: 15, top: '-2px', position: 'relative' }}
                        />
                      </Col>
                      <Col>
                        {product?.ratings?.length > 0 ? (
                          <span className="text-16-normal">30 {t('ratings')}</span>
                        ) : (
                          <span className="text-16-normal">{t('noRatings')}</span>
                        )}
                      </Col>
                    </Row>
                  </Col> */}
                </Row>
              </Col>
              <Col span={24}>
                <Row type="flex" justify="space-between" align="bottom">
                  <Col>
                    {product.stock < 3 && product.stock > 0 && (
                      <div className="limited-quantity">{t('limitedQuantity')}</div>
                    )}
                    {(product.stock === 0 ||
                      (product.stock === null &&
                        product.inventoryTracking === 'variant' &&
                        product.variants.length === 0)) &&
                      product?.availability?.value !== 'notAvailable' && (
                        <div className="text-14-red">{t('outOfStock')}</div>
                      )}
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* product title */}
            <Row>
              <Col align="left" span={20}>
                <span className="text-21-bold">{product.title}</span>
              </Col>
              <Col span={4}>
                {product.onSale.value ? (
                  <div className="circle-item-product">
                    <p className="text-16-normal light-text">
                      -{Math.round(product.sale.percentage)}%
                    </p>
                  </div>
                ) : null}
              </Col>
            </Row>
            {/* sku code */}
            <Row>
              <Col className="mt-10" span={24}>
                {product.sku ? (
                  <span className="text-14-mute">
                    {t('sku')}
                    {product.sku}
                  </span>
                ) : null}
              </Col>
            </Row>
            <Row className="mt-20" type="flex" align="bottom">
              {/* is available  */}
              <Col>
                <span className="text-15-normal">{product.availability?.label}</span>
              </Col>
              <Col className=" mb-30" span={24}>
                <Row type="flex">
                  {/* product price */}
                  <Col>{showProductPrice()}</Col>
                </Row>
              </Col>
              {product.licenseType === 'hunt' ? (
                <>
                  <Col span={24}>
                    {product.licenseType ? (
                      <div className="license-checkbox-section">
                        <Checkbox onChange={licenceChange}>
                          {getLicenseType(product.licenseType)}

                          {product.licenseType !== 'over18' ? (
                            <a
                              href={getDownloadLink(product.licenseType)}
                              download
                              target="_blank"
                              className="text-12-mute-learn-more"
                              rel="noreferrer noopener"
                            >
                              <p>{t('ProductInfo.license.checkBoxesLink')}</p>
                            </a>
                          ) : null}
                        </Checkbox>
                      </div>
                    ) : null}
                  </Col>
                </>
              ) : null}
            </Row>
            {/* product options */}
            {/* <Row>
              <Col xs={0} xl={24} className="mt-10">
                {product.variants.length > 0 ? (
                  <Col className="product-shortDescription-container">
                    <ProductOptions
                      variants={product.variants}
                      options={product.options}
                      setVariant={setVariant}
                      t={t}
                    />
                  </Col>
                ) : null}
              </Col>
            </Row> */}

            {/* add to cart , add to favorites counter */}
            <Row
              gutter={10}
              className="mt-10"
              type="flex"
              justify="center"
              align="middle"
            >
              <Col xs={24} xl={24}>
                {product?.variants?.length > 0 ? (
                  <Col className="product-shortDescription-container">
                    <ProductOptions
                      variants={product.variants}
                      options={product.options}
                      product={product}
                      setOutOfStockVariant={setOutOfStockVariant}
                      outOfStockVariant={outOfStockVariant}
                      setIsOptionSelected={setIsOptionSelected}
                      setVariant={setVariant}
                      t={t}
                    />
                  </Col>
                ) : null}
              </Col>
              <Col className="mt-20" xs={24} sm={17} md={24}>
                <Row type="flex" justify="space-between">
                  {/* counter */}
                  <Col>
                    <Row type="flex" justify="center" align="middle">
                      <div className="product-counter-container">
                        <button
                          type="button"
                          className="d-flex-center"
                          onClick={() => decrementQuantity(product)}
                        >
                          <span>-</span>
                        </button>
                        <input
                          className="counter-input"
                          type="number"
                          value={quantity}
                          onChange={(value) => onQuantityChange(value, product)}
                        />
                        <button
                          type="button"
                          className="d-flex-center"
                          onClick={() => incrementQuantity(product)}
                        >
                          <span>+</span>
                        </button>
                      </div>
                    </Row>
                  </Col>
                  {/* shopping cart desktop */}
                  <Col xs={0} md={14} lg={16} xl={12}>
                    {product?.availability?.value === 'notAvailable' ? (
                      <Button
                        onClick={() => tryAddProductToCart(product)}
                        className="orange-btn"
                        disabled
                      >
                        {t('addToCart')}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => tryAddProductToCart(product)}
                        className="orange-btn"
                      >
                        {t('addToCart')}
                      </Button>
                    )}
                  </Col>
                  {/* shopping cart mobile */}
                  <Col>
                    <Row gutter={10} type="flex" justify="end">
                      <Col className="ml-20" xs={undefined} md={0}>
                        {product?.availability?.value === 'notAvailable' ? (
                          <Button
                            htmlType="button"
                            className="delete-orange-btn"
                            disabled
                            onClick={() => tryAddProductToCart(product)}
                          >
                            <Icon type="shopping-cart" style={{ fontSize: 18 }} />
                          </Button>
                        ) : (
                          <Button
                            htmlType="button"
                            className="delete-orange-btn"
                            onClick={() => tryAddProductToCart(product)}
                          >
                            <Icon type="shopping-cart" style={{ fontSize: 18 }} />
                          </Button>
                        )}
                      </Col>
                      <Col>
                        {!isFavorite ? (
                          <Button
                            htmlType="button"
                            className="outlined-button-single-product-icon"
                            onClick={() => addProductToFavorites(product)}
                          >
                            <Icon type="heart" style={{ fontSize: 18 }} />
                          </Button>
                        ) : (
                          <Button
                            htmlType="button"
                            className="outlined-button-single-product-icon"
                            onClick={() => addProductToFavorites(product)}
                          >
                            <Icon
                              style={{ color: 'red', fontSize: 18 }}
                              type="heart"
                              theme="filled"
                            />
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* settlements show only on !isLong */}
            {!isLong ? (
              <>
                <Row className="mt-60">
                  {product.settlements?.active ? (
                    <Col className="pl-0" span={24}>
                      <Settlements t={t} settlements={product.settlements} />
                    </Col>
                  ) : null}
                </Row>
              </>
            ) : null}
          </Col>
          {/*   doseis settlements and extras */}
          <Col xs={0} xl={isLong ? 12 : 24} order={isLong ? 1 : 2}>
            <Row>
              <Col lg={24}>
                {product.extras?.length > 0 ? (
                  <Row className="">
                    <Col className="pl-0" xs={24} xl={isLong ? 24 : 12}>
                      <Row>
                        <span className="text-16-bold-black">{t('productUpdate')}</span>
                      </Row>
                      <Row className="section-img-row">
                        <ProductExtras productId={product._id} extras={product.extras} />
                      </Row>
                    </Col>
                  </Row>
                ) : null}
                {isLong ? (
                  <>
                    {product.settlements?.active ? (
                      <Row>
                        <Col className="pl-0" span={isLong ? 24 : 12}>
                          <Settlements t={t} settlements={product.settlements} />
                        </Col>
                      </Row>
                    ) : null}
                  </>
                ) : null}
              </Col>
            </Row>
          </Col>
          <Col xs={24} xl={0} order={!isLong ? 1 : 2}>
            <Row>
              <Col className="mt-30" lg={24}>
                {product.extras?.length > 0 ? (
                  <Collapse className="product-collapse">
                    <Collapse.Panel
                      header={
                        <span className="text-14-normal">{t('productUpdate')}</span>
                      }
                      key="1"
                    >
                      <Row className="">
                        <Col className="pl-0" xs={24} xl={isLong ? 24 : 12}>
                          <Row className="section-img-row">
                            <ProductExtras
                              productId={product._id}
                              extras={product.extras}
                            />
                          </Row>
                        </Col>
                      </Row>
                    </Collapse.Panel>
                  </Collapse>
                ) : null}

                {isLong ? (
                  <>
                    {product.settlements?.active ? (
                      <Row>
                        <Col className="pl-0" span={isLong ? 24 : 12}>
                          <Settlements t={t} settlements={product.settlements} />
                        </Col>
                      </Row>
                    ) : null}
                  </>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
        {/* long product description */}
        <Row className="product-desciption">
          <Col xs={0} xl={24}>
            <Row>
              {/* description */}
              {productLongDescription ? (
                <>
                  {/* title */}
                  <Col span={24} className="mb-30">
                    <span className="text-16-bold-black">{t('longDescription')}</span>
                  </Col>
                  <Col span={24}>
                    <p className="text-16-normal">{productLongDescription || ' '}</p>
                  </Col>
                </>
              ) : null}
            </Row>
          </Col>
          <Col xs={24} xl={0}>
            <Collapse className="product-collapse">
              <Collapse.Panel
                header={
                  <p className="text-14-normal" key="2">
                    ΠΕΡΙΓΡΑΦΗ ΠΡΟΙΟΝΤΟΣ
                  </p>
                }
              >
                {/* description */}
                <Col span={24}>
                  <p className="text-16-normal">{productLongDescription || ' '}</p>
                </Col>
              </Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
        {/* product options mobile */}

        {/* attributes */}
        <Row>
          <Col xs={0} xl={24} className="mt-10">
            {product.attributes.length > 0 ? (
              <Row>
                <div className="border-bottom">
                  <div className="info-section-title-technical">
                    {t('specifications')}
                  </div>
                </div>
                {product.attributes.map((attribute, i) => (
                  <Col key={i.toString()} className="product-attributes-container">
                    <div className="border-bottom">
                      <Row
                        type="flex"
                        justify="start"
                        align="middle"
                        className="mt-15 mb-15"
                      >
                        <Col className="mb-1" span={12}>
                          <p>{attribute.display_name}</p>
                        </Col>
                        <Col className="mb-1 d-flex" span={12}>
                          <ul>
                            {attribute.isCustomText ? (
                              <p className="mr-1 break-spaces">
                                {attribute.customText.split('^').join('\n')}
                              </p>
                            ) : (
                              attribute.values.map((item, idx) => (
                                <>
                                  {item.length > 3 ? (
                                    <>
                                      <li key={idx.toString()}>{item.label}</li>
                                    </>
                                  ) : (
                                    <p key={idx.toString()}>{item.label}</p>
                                  )}
                                </>
                              ))
                            )}
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : null}
          </Col>
          <Col xs={24} xl={0} className="mt-20">
            {product.attributes.length > 0 ? (
              <Collapse className="product-collapse">
                <Collapse.Panel
                  header={<p className="text-14-normal">ΤΕΧΝΙΚΑ ΧΑΡΑΚΤΗΡΙΣΤΙΚΑ</p>}
                  key="1"
                >
                  <Row>
                    {product.attributes.map((attribute, i) => (
                      <Col key={i.toString()} className="product-attributes-container">
                        <div className="border-bottom">
                          <Row
                            type="flex"
                            justify="start"
                            align="middle"
                            className="mt-15 mb-15"
                          >
                            <Col className="mb-1" span={12}>
                              <p>{attribute.display_name}</p>
                            </Col>
                            <Col className="mb-1 d-flex" span={12}>
                              <ul className="list-unstyled">
                                {attribute.isCustomText ? (
                                  <p className="mr-1">{attribute.customText}</p>
                                ) : (
                                  attribute.values.map((item, idx) => (
                                    <li key={idx.toString()}>{item.label}</li>
                                  ))
                                )}
                              </ul>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Collapse.Panel>
              </Collapse>
            ) : null}
          </Col>
        </Row>

        {/* technologies */}
        {product.technologies.length > 0 ? (
          <>
            <Row className="mt-50">
              <Col className="mb-50" span={24}>
                <Row className="mb-10">
                  <p className="text-16-bold-black">ΤΕΧΝΟΛΟΓΙΕΣ</p>
                </Row>
                <Divider type="horizontal" />
              </Col>
              <Col span={24}>
                <ProductTechnologies
                  technologies={product.technologies}
                  productId={product._id}
                />
              </Col>
            </Row>
          </>
        ) : null}

        {/* related products */}
        {product.relatedProducts.length > 0 ? (
          <>
            <Row>
              <Col className="mt-30 mb-30" span={24}>
                <Col className="mb-30">
                  <Row className="mb-10">
                    <span className="text-16-bold-black">{t('relatedProducts')}</span>
                  </Row>
                  <Divider type="horizontal" />
                </Col>
                <Slider {...responsiveSliderSettings}>
                  {product.relatedProducts.map((item) => (
                    <Col className="mr-10 list">
                      <ProductShort
                        addProductToCart={() => addProductToCart(item)}
                        addProductToFavorites={() => addToFavorites(item._id)}
                        customer={customer}
                        favorites={favorites}
                        product={item}
                        settings={settings}
                        t={t}
                        origin="slider"
                      />
                    </Col>
                  ))}
                </Slider>
              </Col>
            </Row>
          </>
        ) : null}
      </>
    </>
  );
};

export default ProductDesktop;
